module.exports = __webpack_public_path__ + "7ca1fd54d211ffa409349b29ba30878d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/dynamic/wx_xcx_ma.jpg
// module id = 34
// module chunks = 2 3 4 5 6 7 8 9 10 11 12 13 14 16 17 18 19 20 21 22 23 25 26 27 28 29 30 31 32 33 34 35